import { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import styles from './index.module.scss';
import { Button } from '@/components';

export type PartnerDescriptionProps =
  SliceComponentProps<Content.PartnerDescriptionSlice>;

const PartnerDescription = ({
  slice,
}: PartnerDescriptionProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.container}
    >
      <div className={styles.titleWrapper}>
        <div className={styles.title}>
          <PrismicRichText field={slice.primary.title} />
        </div>
        <p className={styles.subtitle}>{slice.primary.subtitle}</p>
        <Button
          text={slice.primary.button_text}
          link={slice.primary.button_link}
          styles={styles.button}
        />
      </div>
      <PrismicNextImage field={slice.primary.image} className={styles.img} />
      <PrismicNextImage
        field={slice.primary.mob_image}
        className={styles.mobImg}
      />
      <div className={styles.firstEllipse} />
      <div className={styles.secondEllipse} />
      <div className={styles.thirdEllipse} />
    </section>
  );
};

export default PartnerDescription;
